// ========== 设备性能检测工具 ==========

/**
 * 检测设备性能等级
 * @returns {'low' | 'high'} 性能等级
 */
export function detectPerformance() {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const isLowEndCPU = navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4;
    const isSlowGPU = !window.WebGLRenderingContext;
    const isLowMemory = navigator.deviceMemory && navigator.deviceMemory < 4;
    
    // 综合判断设备性能
    if (isMobile || isLowEndCPU || isSlowGPU || isLowMemory) {
        console.log('🔻 检测到低端设备，启用性能优化模式');
        return 'low';
    }
    console.log('✅ 检测到高端设备，使用标准模式');
    return 'high';
}

/**
 * 获取性能倍数（用于调整粒子数量等）
 * @param {string} performanceLevel - 性能等级
 * @returns {number} 性能倍数
 */
export function getPerformanceMultiplier(performanceLevel) {
    return performanceLevel === 'low' ? 0.5 : 1.0;
}

/**
 * 获取推荐的目标帧率
 * @param {string} performanceLevel - 性能等级
 * @returns {number} 目标帧率
 */
export function getTargetFPS(performanceLevel) {
    return performanceLevel === 'low' ? 24 : 30;
}

// 导出单例性能检测结果
export const devicePerformance = detectPerformance();
export const performanceMultiplier = getPerformanceMultiplier(devicePerformance);
export const targetFPS = getTargetFPS(devicePerformance);
